import { render, staticRenderFns } from "./SurveyAnswerCell.vue?vue&type=template&id=cbc80cc8&scoped=true"
import script from "./SurveyAnswerCell.vue?vue&type=script&lang=js"
export * from "./SurveyAnswerCell.vue?vue&type=script&lang=js"
import style0 from "./SurveyAnswerCell.vue?vue&type=style&index=0&id=cbc80cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc80cc8",
  null
  
)

export default component.exports